<template>
  <a-card :bordered="false">
    <a-tabs v-model="activeTab">

      <!-- ===== Tab1: 同比基准值 ===== -->
      <a-tab-pane key="yoy" tab="同比基准值">
        <div style="margin-bottom:12px">
          <a-button type="primary" icon="plus" @click="openYoyModal()">新增</a-button>
          <span style="margin-left:12px;color:#888;font-size:12px">
            日期填去年同月的月末（如查询5月数据则填2025-05-31），数值为该日累计签单佣金（万元）。未配置则同比显示"N/A"。
          </span>
        </div>
        <a-table
          :columns="yoyColumns"
          :dataSource="yoyList"
          :pagination="false"
          :loading="yoyLoading"
          rowKey="id"
          size="small"
          bordered
        >
          <template slot="action" slot-scope="text, record">
            <a @click="openYoyModal(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确认删除？" @confirm="deleteConfig(record.id, 'yoy')">
              <a style="color:#f5222d">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-tab-pane>

      <!-- ===== Tab2: 行调整偏移量 ===== -->
      <a-tab-pane key="offset" tab="行调整偏移量">
        <div style="margin-bottom:12px">
          <a-button type="primary" icon="plus" @click="openOffsetModal()">新增</a-button>
          <span style="margin-left:12px;color:#888;font-size:12px">
            对报表某一行某一列加减固定数值（万元）。调整列选"标准收入折算"时可填写折算公式说明。
          </span>
        </div>
        <a-table
          :columns="offsetColumns"
          :dataSource="offsetList"
          :pagination="false"
          :loading="offsetLoading"
          rowKey="id"
          size="small"
          bordered
        >
          <template slot="configCol" slot-scope="text">{{ colLabel(text) }}</template>
          <template slot="action" slot-scope="text, record">
            <a @click="openOffsetModal(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确认删除？" @confirm="deleteConfig(record.id, 'offset')">
              <a style="color:#f5222d">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-tab-pane>

      <!-- ===== Tab3: 分年度未到账 ===== -->
      <a-tab-pane key="year" tab="分年度未到账">
        <div style="margin-bottom:12px">
          <a-button type="primary" icon="plus" @click="openYearModal()">新增</a-button>
          <span style="margin-left:12px;color:#888;font-size:12px">
            配置各行22/23/24年未到账佣金参考值（万元），仅用于页面展示，不参与主表计算。
          </span>
        </div>
        <a-table
          :columns="yearColumns"
          :dataSource="yearList"
          :pagination="false"
          :loading="yearLoading"
          rowKey="id"
          size="small"
          bordered
        >
          <template slot="action" slot-scope="text, record">
            <a @click="openYearModal(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确认删除？" @confirm="deleteConfig(record.id, 'year')">
              <a style="color:#f5222d">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-tab-pane>

    </a-tabs>

    <!-- ===== 同比基准值 Modal ===== -->
    <a-modal
      v-model="yoyModal.visible"
      :title="yoyModal.id ? '编辑同比基准值' : '新增同比基准值'"
      @ok="saveYoy"
      :confirmLoading="yoyModal.saving"
    >
      <a-form-model :model="yoyModal.form" :label-col="{span:6}" :wrapper-col="{span:16}">
        <a-form-model-item label="日期">
          <a-date-picker v-model="yoyModal.form.date" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="去年同月末佣金（万元）">
          <a-input-number v-model="yoyModal.form.value" :precision="4" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input v-model="yoyModal.form.remark" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- ===== 行调整偏移量 Modal ===== -->
    <a-modal
      v-model="offsetModal.visible"
      :title="offsetModal.id ? '编辑行调整偏移量' : '新增行调整偏移量'"
      @ok="saveOffset"
      :confirmLoading="offsetModal.saving"
    >
      <a-form-model :model="offsetModal.form" :label-col="{span:6}" :wrapper-col="{span:16}">
        <a-form-model-item label="行标签">
          <a-input v-model="offsetModal.form.key" placeholder="与报表中的行名称完全一致" />
        </a-form-model-item>
        <a-form-model-item label="调整列">
          <a-select v-model="offsetModal.form.col" style="width:100%">
            <a-select-option value="cleanPremium">签单保费</a-select-option>
            <a-select-option value="cleanBrokerage">签单佣金</a-select-option>
            <a-select-option value="receivedBrokerage">到账佣金</a-select-option>
            <a-select-option value="unreceivedBrokerage">未到账佣金</a-select-option>
            <a-select-option value="standardIncome">标准收入折算</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="偏移量（万元）">
          <a-input-number v-model="offsetModal.form.value" :precision="4" style="width:100%"
            placeholder="正数增加，负数减少" />
        </a-form-model-item>
        <a-form-model-item v-if="offsetModal.form.col === 'standardIncome'" label="折算公式">
          <a-input v-model="offsetModal.form.formula" placeholder="如：到账去税佣金（内部互转冲减）" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input v-model="offsetModal.form.remark" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- ===== 分年度未到账 Modal ===== -->
    <a-modal
      v-model="yearModal.visible"
      :title="yearModal.id ? '编辑分年度未到账' : '新增分年度未到账'"
      @ok="saveYear"
      :confirmLoading="yearModal.saving"
    >
      <a-form-model :model="yearModal.form" :label-col="{span:6}" :wrapper-col="{span:16}">
        <a-form-model-item label="行标签">
          <a-input v-model="yearModal.form.key" placeholder="与报表中的行名称完全一致" />
        </a-form-model-item>
        <a-form-model-item label="年份">
          <a-select v-model="yearModal.form.col" style="width:100%">
            <a-select-option value="2024">2024年</a-select-option>
            <a-select-option value="2023">2023年</a-select-option>
            <a-select-option value="2022">2022年</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="未到账金额（万元）">
          <a-input-number v-model="yearModal.form.value" :precision="4" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input v-model="yearModal.form.remark" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import { getAction, postAction, deleteAction } from '@/api/manage'
import moment from 'moment'

const COL_LABELS = {
  cleanPremium: '签单保费',
  cleanBrokerage: '签单佣金',
  receivedBrokerage: '到账佣金',
  unreceivedBrokerage: '未到账佣金',
  standardIncome: '标准收入折算'
}

export default {
  name: 'DailyCheckSettings',
  data() {
    return {
      activeTab: 'yoy',
      yoyLoading: false,
      offsetLoading: false,
      yearLoading: false,
      yoyList: [],
      offsetList: [],
      yearList: [],
      yoyColumns: [
        { title: '日期', dataIndex: 'configKey', width: 120 },
        { title: '去年同月末佣金（万元）', dataIndex: 'configValue', width: 160, align: 'right' },
        { title: '备注', dataIndex: 'remark' },
        { title: '操作', scopedSlots: { customRender: 'action' }, width: 100, align: 'center' }
      ],
      offsetColumns: [
        { title: '行标签', dataIndex: 'configKey', width: 140 },
        { title: '调整列', dataIndex: 'configCol', width: 120, scopedSlots: { customRender: 'configCol' } },
        { title: '偏移量（万元）', dataIndex: 'configValue', width: 120, align: 'right' },
        { title: '折算公式', dataIndex: 'formula', width: 200 },
        { title: '备注', dataIndex: 'remark' },
        { title: '操作', scopedSlots: { customRender: 'action' }, width: 100, align: 'center' }
      ],
      yearColumns: [
        { title: '行标签', dataIndex: 'configKey', width: 140 },
        { title: '年份', dataIndex: 'configCol', width: 80, align: 'center' },
        { title: '未到账金额（万元）', dataIndex: 'configValue', width: 150, align: 'right' },
        { title: '备注', dataIndex: 'remark' },
        { title: '操作', scopedSlots: { customRender: 'action' }, width: 100, align: 'center' }
      ],
      yoyModal: {
        visible: false,
        saving: false,
        id: null,
        form: { date: null, value: null, remark: '' }
      },
      offsetModal: {
        visible: false,
        saving: false,
        id: null,
        form: { key: '', col: 'cleanBrokerage', value: null, formula: '', remark: '' }
      },
      yearModal: {
        visible: false,
        saving: false,
        id: null,
        form: { key: '', col: '2024', value: null, remark: '' }
      }
    }
  },
  created() {
    this.loadYoy()
    this.loadOffset()
    this.loadYear()
  },
  methods: {
    loadYoy() {
      this.yoyLoading = true
      getAction('/biz/dailyCheckConfig/yoyList').then(res => {
        if (res.success) this.yoyList = res.result || []
      }).finally(() => { this.yoyLoading = false })
    },
    loadOffset() {
      this.offsetLoading = true
      getAction('/biz/dailyCheckConfig/offsetList').then(res => {
        if (res.success) this.offsetList = res.result || []
      }).finally(() => { this.offsetLoading = false })
    },
    loadYear() {
      this.yearLoading = true
      getAction('/biz/dailyCheckConfig/yearList').then(res => {
        if (res.success) this.yearList = res.result || []
      }).finally(() => { this.yearLoading = false })
    },
    openYoyModal(record) {
      if (record) {
        this.yoyModal.id = record.id
        this.yoyModal.form = {
          date: moment(record.configKey),
          value: record.configValue,
          remark: record.remark || ''
        }
      } else {
        this.yoyModal.id = null
        this.yoyModal.form = { date: null, value: null, remark: '' }
      }
      this.yoyModal.visible = true
    },
    saveYoy() {
      const { id, form } = this.yoyModal
      if (!form.date || form.value == null) {
        this.$message.warning('日期和数值不能为空')
        return
      }
      this.yoyModal.saving = true
      const payload = {
        id: id || undefined,
        configType: 'yoy_base',
        configKey: form.date.format('YYYY-MM-DD'),
        configCol: null,
        configValue: form.value,
        remark: form.remark
      }
      postAction('/biz/dailyCheckConfig/save', payload).then(res => {
        if (res.success) {
          this.$message.success('保存成功')
          this.yoyModal.visible = false
          this.loadYoy()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      }).finally(() => { this.yoyModal.saving = false })
    },
    openOffsetModal(record) {
      if (record) {
        this.offsetModal.id = record.id
        this.offsetModal.form = {
          key: record.configKey,
          col: record.configCol,
          value: record.configValue,
          formula: record.formula || '',
          remark: record.remark || ''
        }
      } else {
        this.offsetModal.id = null
        this.offsetModal.form = { key: '', col: 'cleanBrokerage', value: null, formula: '', remark: '' }
      }
      this.offsetModal.visible = true
    },
    saveOffset() {
      const { id, form } = this.offsetModal
      if (!form.key || !form.col || form.value == null) {
        this.$message.warning('行标签、调整列和偏移量不能为空')
        return
      }
      this.offsetModal.saving = true
      const payload = {
        id: id || undefined,
        configType: 'row_offset',
        configKey: form.key,
        configCol: form.col,
        configValue: form.value,
        formula: form.col === 'standardIncome' ? form.formula : null,
        remark: form.remark
      }
      postAction('/biz/dailyCheckConfig/save', payload).then(res => {
        if (res.success) {
          this.$message.success('保存成功')
          this.offsetModal.visible = false
          this.loadOffset()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      }).finally(() => { this.offsetModal.saving = false })
    },
    openYearModal(record) {
      if (record) {
        this.yearModal.id = record.id
        this.yearModal.form = {
          key: record.configKey,
          col: record.configCol,
          value: record.configValue,
          remark: record.remark || ''
        }
      } else {
        this.yearModal.id = null
        this.yearModal.form = { key: '', col: '2024', value: null, remark: '' }
      }
      this.yearModal.visible = true
    },
    saveYear() {
      const { id, form } = this.yearModal
      if (!form.key || !form.col || form.value == null) {
        this.$message.warning('行标签、年份和金额不能为空')
        return
      }
      this.yearModal.saving = true
      const payload = {
        id: id || undefined,
        configType: 'year_unreceived',
        configKey: form.key,
        configCol: form.col,
        configValue: form.value,
        remark: form.remark
      }
      postAction('/biz/dailyCheckConfig/save', payload).then(res => {
        if (res.success) {
          this.$message.success('保存成功')
          this.yearModal.visible = false
          this.loadYear()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      }).finally(() => { this.yearModal.saving = false })
    },
    deleteConfig(id, type) {
      deleteAction('/biz/dailyCheckConfig/delete', { id }).then(res => {
        if (res.success) {
          this.$message.success('删除成功')
          if (type === 'yoy') this.loadYoy()
          else if (type === 'year') this.loadYear()
          else this.loadOffset()
        } else {
          this.$message.error(res.message || '删除失败')
        }
      })
    },
    colLabel(col) {
      return COL_LABELS[col] || col
    }
  }
}
</script>
